const CurrencyService = {

    getActive : (currencies) => {
        return  currencies ?  currencies.filter(currency => currency.state ==='ACTIVE') : [];
    },

    mergeCurrencies : (currencies1, currencies2) => {
        const toNumber = (v) => (typeof v === 'string' ? Number(v) : v) || 0;
        const result = [...currencies1];

        currencies2.forEach(eachNewCurrency => {
            const existingIndex = result.findIndex(existCurrency => existCurrency.currencyId === eachNewCurrency.currencyId);

            if (existingIndex !== -1) {
                result[existingIndex] = {
                    ...result[existingIndex],
                    value: toNumber(result[existingIndex].value) + toNumber(eachNewCurrency.value)
                };
            } else {
                result.push({ ...eachNewCurrency, value: toNumber(eachNewCurrency.value) });
            }
        });

        return result;
    },

    getValue: (currencyValues, currency) => {
        const currencyValue = currencyValues.find(currencyValue => currencyValue.currency === currency);
        return currencyValue ? currencyValue.value : 0;
    },

    negative : (currencies) => {
        return currencies.map(currency => ({
            ...currency,
            value: -currency.value
        }));
    }
}

export default CurrencyService